import React from "react"
import propTypes from "prop-types"
import i18n from "i18n"
import { FormControlLabel, Switch, Typography } from "@mui/material"

const OptionSwitch = ({
  i18nKey,
  state,
  setState,
  inputKey,
  tipo,
  setDownloadBudgetConfig,
  disabled = false,
  onToggleBlocked = null,
  testId,
}) => {
  const label = i18n.t(i18nKey)

  const handleChange = (_event, checked) => {
    if (disabled) return

    if (!state && checked && onToggleBlocked) {
      onToggleBlocked()
      return
    }

    setState(checked)
    setDownloadBudgetConfig(tipo, inputKey, checked)
  }

  return (
    <FormControlLabel
      labelPlacement="start"
      data-testid={testId ? `${testId}-row` : undefined}
      sx={{
        m: 0,
        mx: 0,
        mb: 0,
        py: 0.25,
        pr: 0,
        width: "100%",
        maxWidth: 320,
        justifyContent: "space-between",
        alignItems: "center",
        "& .MuiFormControlLabel-label": {
          flex: 1,
          mr: 0.75,
        },
      }}
      control={
        <Switch
          checked={state}
          disabled={disabled}
          onChange={handleChange}
          size="medium"
          color="primary"
          inputProps={{
            "aria-label": label,
            ...(testId ? { "data-testid": testId } : {}),
          }}
        />
      }
      label={
        <Typography
          variant="body2"
          sx={{ color: "#414141", lineHeight: 1.35, fontSize: 13 }}
        >
          {label}
        </Typography>
      }
    />
  )
}

OptionSwitch.propTypes = {
  i18nKey: propTypes.string.isRequired,
  state: propTypes.bool.isRequired,
  setState: propTypes.func.isRequired,
  inputKey: propTypes.string.isRequired,
  tipo: propTypes.string.isRequired,
  setDownloadBudgetConfig: propTypes.func.isRequired,
  disabled: propTypes.bool,
  onToggleBlocked: propTypes.func,
  testId: propTypes.string,
}

export default OptionSwitch
